import { Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { CSSProperties } from "react";
import { Token } from "../theme";

export interface Props {
  label?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
  size?: any;
  customStyle?: CSSProperties;
}

export const CheckboxComponent = ({ label, checked, disabled, size, onChange, customStyle }: Props) => {
  return (
    <FormGroup>
      <FormControlLabel
        label={<Typography color={!checked ? Token.textTertiary : "default"}>{label || ""}</Typography>}
        control={
          <Checkbox
            disabled={disabled}
            checked={checked}
            onChange={() => onChange()}
            sx={{
              "& .MuiSvgIcon-root": { fontSize: size },
              color: Token.textTertiary,
              "&.Mui-checked": { color: Token.actionPrimary },
            }}
          />
        }
        style={{ ...customStyle }}
      />
    </FormGroup>
  );
};
